module.exports = __webpack_public_path__ + "static/trees-bg-962c6ec3b25145b8c265a201f78e3d98.svg";